/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import useStyles from '../../../../assets/styles/pages/Address';
import Header from '../../../../components/Header';

// import svg
import { ReactComponent as IconAdd } from '../../../../assets/images/svg/address_list/icon_add.svg';
import { ReactComponent as IconDelete } from '../../../../assets/images/svg/address_list/icon_delete.svg';
import { ReactComponent as IconLocation } from '../../../../assets/images/svg/address_list/icon_local.svg';
import { ReactComponent as IconInfo } from '../../../../assets/images/svg/utils/info.svg';

import FooterMenuMain from '../../../../components/FooterMenuMain';
import { api } from '../../../../services';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { useLoadingContext } from '../../../../providers/use-loading';
import { useSignInContext } from '../../../../providers/use-signin';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const Address: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data, signingOut } = useSignInContext();
  const navigate = useNavigate();

  const [addresses, setAddresses] = useState<any>();
  const [openAddressDelete, setOpenAddressDelete] = useState<any>(false);
  const [idAddressDelete, setIdAddressDelete] = useState({
    idEndereco: 0,
    posicao: 0,
  });

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleListAddress = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listAddress({
          nr_operacao: 10,
          idUsuario: data.user?.idUsuario,
        });

      setAddresses(result.data);
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'listAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao listar os endereços');
      }
    } finally {
      createloading(false);
    }
  };

  const ShowModalDeleteAddress = (idAddress: number, index: number) => {
    setIdAddressDelete({
      idEndereco: idAddress,
      posicao: index,
    });
    setOpenAddressDelete(true);
  };

  const handleDeleteAddress = async (idEndereco: number, index: number) => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.deleteAddress({
          nr_operacao: 12,
          idUsuario: data.user?.idUsuario,
          idEndereco,
        });

      if (result.data.retorno === 'OK') {
        addresses.splice(index, 1);
        setAddresses([...addresses]);
        toast.success('Endereço excluído com sucesso');
      } else {
        toast.error(result.data.mensagem);
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'deleteAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Não foi possível excluir o endereço. Tente novamente');
      }
    } finally {
      createloading(false);
      setOpenAddressDelete(false);
    }
  };

  useEffect(() => {
    if (data.user?.idUsuario) {
      handleListAddress();
    }
  }, [data.user?.idUsuario]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="address" />

      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        marginBottom="150px"
      >
        {addresses &&
          addresses.map((address: any, index: any) => (
            <Grid
              key={address.idEndereco}
              container
              item
              justifyContent="center"
              alignItems="center"
              textAlign="center"
            >
              <Grid item xs={1} className={classeStyle.gridIconLocation}>
                <IconLocation />
              </Grid>
              <Grid item xs={8} className={classeStyle.gridTextAddressList}>
                <h4 className={classeStyle.textDesAddress}>
                  {address.dsRua}, {address.nrRua}
                </h4>
                <p className={classeStyle.textDescriptionAddress}>
                  {address.dsComplemento}
                </p>
                <p className={classeStyle.textDescriptionAddress}>
                  {address.dsBairro} - {address.dsCidade}({address.dsEstado})
                </p>
              </Grid>
              <Grid
                item
                xs={1}
                className={classeStyle.gridIconDelete}
                onClick={() =>
                  ShowModalDeleteAddress(address.idEndereco, index)
                }
              >
                <IconDelete />
              </Grid>
            </Grid>
          ))}
      </Grid>
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Button
          variant="contained"
          className={classeStyle.btnNewAddress}
          style={{
            position: 'fixed',
          }}
          onClick={() => handleToPage('/dashboard/user/address/create')}
        >
          <IconAdd className={classeStyle.iconAdd} /> Novo Endereço
        </Button>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openAddressDelete}
        onClose={() => setOpenAddressDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '680px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Deseja deletar este endereço?
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            onClick={() =>
              handleDeleteAddress(
                idAddressDelete.idEndereco,
                idAddressDelete.posicao,
              )
            }
            variant="contained"
          >
            Confirmar
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenAddressDelete(false)}
            className={classeStyle.btnCancel}
          >
            Cancelar
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default Address;
